const LOCAL_FONT_PATH = '/assets/fonts/fort';
const REMOTE_FONT_PATH = '/fonts';

export function GET_FONT_PATH(environment: any) {
	if (environment?.production && window['ASSET_PREFIX_PATH']) {
		let assetPath = window['ASSET_PREFIX_PATH'];
		assetPath = assetPath.endsWith('/') ? assetPath.slice(0, -1) : assetPath;
		return assetPath + REMOTE_FONT_PATH;
	}
	return environment?.fontPath ?? LOCAL_FONT_PATH;
}
